import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UrlFormatter } from 'shared';

/**
 * Native port of the v1 `SettingsLanguages` factory
 * (account-v1/src/core/api/settingsLanguages.js). WS5 #10 Stage A inc 2s:
 * replaces the `$injector.get('SettingsLanguages')` grab in ft-campaign-prestay
 * (its only native consumer — the setupCreating path).
 *
 * NOTE the documented v1 bug rides ABOVE this service unchanged: the campaign
 * setupCreating consumer reads `data.languages.item` but this endpoint returns
 * `{id, item}` — broken identically in v1, the frozen baseline, and the native
 * port (see reference_account_v1_campaign_create_broken).
 */
@Injectable({ providedIn: 'root' })
export class SettingsLanguagesV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `SettingsLanguages.get(params)`. */
  get(params: any): Promise<any> {
    return firstValueFrom(
      this.http.get(UrlFormatter.format('/api/:propertyId/properties/:propertyId/settings/languages', params)),
    );
  }

  /** v1 `SettingsLanguages.put(params, model)`. */
  put(params: any, model: any): Promise<any> {
    return firstValueFrom(
      this.http.put(UrlFormatter.format('/api/:propertyId/properties/:propertyId/settings/languages', params), model),
    );
  }
}
